import Vue from 'vue'
import Vuex from 'vuex'

import defaultState from '@/store/defaultStates'
import getters from '@/store/getters'
import actions from '@/store/actions'
import mutations from '@/store/mutations'
import modules from '@/store/modules'
import embedAppPlugin from '@/store/modules/embed-app/embed-app.plugin'

Vue.use(Vuex)
export default new Vuex.Store({
  state: defaultState,
  mutations,
  actions,
  modules,
  getters,
  plugins: [
    modules.nextback.plugin,
    modules.participantModule.plugin,
    modules.leaderboard.plugins.updateLeaderboardVisibility,
    modules.quiz.plugins.updateQuizResponse,
    modules.logger.plugin,
    ...modules.kvSync.plugins,
    ...modules.participantModule.plugins,
    ...modules.audienceAudio.plugins,
    embedAppPlugin,
  ],
})
